import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "../api/axios";

function ProtectedRoute({ children, moduleName }) {
  const [user, setUser] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserAndPermissions = async () => {
      try {
        const userRes = await axios.get("/api/user", { withCredentials: true });
        const permissionRes = await axios.get("/api/permissions", {
          withCredentials: true,
        });

        setUser(userRes.data);
        setPermissions(permissionRes.data.permissions || []);
        setModules(permissionRes.data.modules || []);
      } catch (err) {
        console.error(
          "User not authenticated or permission fetch failed:",
          err
        );
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    fetchUserAndPermissions();
  }, []);

  const canView = (moduleName) => {
    const module = modules.find((m) =>
      m.name.toLowerCase().includes(moduleName.toLowerCase())
    );
    if (!module) return false;

    return permissions.some(
      (p) =>
        p.module_id === module.id &&
        p.role_id === user?.role_id &&
        p.can_view === 1
    );
  };

  if (loading) return <div>Loading...</div>;

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (moduleName) {
    if (
      moduleName.toLowerCase() === "admin dashboard" &&
      (user.role_id === 1 || user.role_id === 2)
    ) {
      // Allow
    } else if (
      moduleName.toLowerCase() === "user dashboard" &&
      user.role_id === 3
    ) {
      // Allow
    } else if (!canView(moduleName)) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
}

export default ProtectedRoute;
